import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SongLibrary, SongLibrarySong } from '../song/SongLibrary';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-view-songs',
  templateUrl: './Songs.html',
  styleUrls: ['./style.css']
})
export class AppViewSongs {
  private lib: SongLibrary[] = [];
  public artist: string = '';
  constructor(private readonly http: HttpClient, private readonly route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.artist = ('' + (params['artist'] ? params['artist'] : this.artist));
    });
    this.loadLib();
  }
  private loadLib() {
    this.http.get<SongLibrary[]>('/assets/songs/index.json')
        .subscribe(
          (data: SongLibrary[]) => {
            console.info('Loaded SongLibrary:', data);
            this.lib = data;
          },
          (error: any) => {
            console.error('Failed to load SongLibrary:', error);
          }
        );
  }

  public get artists(): {key: string, artist: string}[] {
    const ret: {key: string, artist: string}[] = [];
    this.lib.forEach((entry: SongLibrary) => ret.push({key: entry.key, artist: entry.artist}));
    return ret;
  }

  public get songs(): {key: string, title: string}[] {
    const ret: {key: string, title: string}[] = [];
    this.lib
      .filter((entry: SongLibrary) => entry.key === this.artist)
      .forEach((entry: SongLibrary) => entry.songs.forEach((s: SongLibrarySong) => {
        ret.push({key: s.key, title: s.title});
      }));
    return ret;
  }
}
